/** 2 since the layout stage (AD-404 §8): every generated plan carries `layout`. */
export const DUNGEON_PLAN_SCHEMA_VERSION = 2;
export const DUNGEON_GENERATOR_VERSION = '2.0.0';
export const DUNGEON_ROOM_ROLES = [
    'entrance',
    'combat',
    'traversal',
    'puzzle',
    'rest',
    'treasure',
    'miniboss',
    'boss',
    'exit',
];
export const DUNGEON_CONNECTION_KINDS = ['open', 'door', 'sealed-gate'];
export const DUNGEON_OBJECTIVE_KINDS = [
    'clear-room',
    'defeat-boss',
    'discover-room',
    'complete-dungeon',
];
export const DUNGEON_REWARD_SOURCES = ['boss', 'optional', 'completion'];
export const DUNGEON_PACING_BEATS = ['calm', 'build', 'peak', 'exhale'];
export const DUNGEON_CHAMBER_SHAPES = ['rect', 'l', 't', 'octagon'];
export const DUNGEON_CORRIDOR_BANDS = ['short', 'normal', 'long'];
export class DungeonGenerationError extends Error {
    problems;
    constructor(problems) {
        super(`procedural dungeon generation failed:\n${problems.map((p) => `${p.path}: ${p.message}`).join('\n')}`);
        this.problems = problems;
        this.name = 'DungeonGenerationError';
    }
}
//# sourceMappingURL=types.js.map